// SPDX-License-Identifier: AGPL-3.0-or-later

import {TABLE_GAME_LEAGUES, TABLE_GAME_RANKED_KINDS} from '@fluxer/constants/src/TableGameConstants';
import {Int32Type} from '@fluxer/schema/src/primitives/SchemaPrimitives';
import {z} from 'zod';

export const TableGameRankedKindSchema = z.enum(TABLE_GAME_RANKED_KINDS);

export const TableGameLeagueSchema = z.enum(TABLE_GAME_LEAGUES);

export const TableGameProfileLeague = z.object({
	game: TableGameRankedKindSchema,
	league: TableGameLeagueSchema,
	rr: Int32Type.nullable().describe('Rank rating; only in the legend league'),
	rank: Int32Type.nullable().describe('Place on the global leaderboard; only in the legend league'),
});
export type TableGameProfileLeague = z.infer<typeof TableGameProfileLeague>;
